import styled from 'styled-components';

export const ExpandedButton = styled.div`
  border: 1px solid #bac1c9;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  cursor: pointer;
  padding: 10px;
  display: flex;
`;

export const ExpandedButtonText = styled.span`
  font-size: 11px;
  color: #5d6e81;
`;
